import { render, staticRenderFns } from "./RePassportPhotos.vue?vue&type=template&id=24ec17e2&scoped=true"
import script from "./RePassportPhotos.vue?vue&type=script&lang=js"
export * from "./RePassportPhotos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ec17e2",
  null
  
)

export default component.exports